import bankService from "../../services/bankService";
import { VIEW_ALL_BANKS } from "../actionTypes/index";

export const getAllBanksAction = (payload) => async (dispatch) => {
  try {
    dispatch({ type: VIEW_ALL_BANKS, payload: { loading: true } });
    const { data: body } = await bankService.getAllBanks(payload);

    const { status, message, data } = body;

    if (status === 200) {
      dispatch({
        type: VIEW_ALL_BANKS,
        payload: {
          loading: false,
          status,
          message,
          data,
        },
      });
    } else {
      dispatch({
        type: VIEW_ALL_BANKS,
        payload: { loading: false, status, message, data },
      });
    }
  } catch (error) {
    dispatch({
      type: VIEW_ALL_BANKS,
      payload: { loading: false, status, message, data },
    });
  }
};
